/* global angular */

const DEBUG = false;

angular.module('atex.aceui.service').factory('ClipboardService',
  ['Application', 'AuthenticationService', 'ContentEventService', 'ContentService', 'ErrorMessagingService',

    function (Application, AuthenticationService, ContentEventService, ContentService, ErrorMessagingService) {

      const CLIPBOARD_ALIAS = (id_postfix) => `atex.aceui.Clipboard-${id_postfix}`;
      let requests = {};

      ContentEventService.addSubscriptions ({
        CLIPBOARD_UPDATE: {
          eventType: 'UPDATE',
          system: { contentType: ['aceClipboardContent'] }
        }
      });

      const getContent = ({ alias, namespace }) => {
        DEBUG && console.log ('GET CLIPBOARD CONTENT', requests[alias] || 'new request');
        requests[alias] = requests[alias] || ContentService.getContent ({ alias: `${namespace}/${alias}`, view: 'aceLatest' })
          .then ((result) => { requests[alias] = undefined; return result; })
          .catch ((error) => {
            requests[alias] = undefined;
            error.cause = 'ClipboardService: ' + error.cause;
            throw error;
          });
        return requests[alias];
      };

      return {
        /**
         * Get the content of the current user's clipboard.
         * The return value is an Array containing 'clips':
         *
         * [
         *   {
         *     id, // The clip id, i.e. an alias for a content
         *     type,  // The clip type, i.e. a contentType
         *   },
         *   ...
         * ]
         *
         * @async
         * @returns {Array} - An array of clips: [{ id, type }, ...]
         * @throws {atex.aceui.error.Error}
         */
        getClipboard: function () {
          return AuthenticationService.callWithAuthentication (({ principalId, userId }) => {
            DEBUG && console.log ('GET CLIPBOARD FOR ', principalId || userId);
            return getContent ({ alias: CLIPBOARD_ALIAS (principalId || userId), namespace: 'aceUI' })
              .then ((response) => {
                DEBUG && console.log ('GET CLIPBOARD - OK');
                const clips = atex.aceui.ObjectUtils.getByPath (response, 'content/aspects/aceClipboard/content');
                return clips;
              })
              .catch ((error) => {
                if (error.type === atex.aceui.error.types.NOT_FOUND) {
                  DEBUG && console.log ('GET CLIPBOARD - NOT FOUND', CLIPBOARD_ALIAS (principalId || userId));
                  return [];
                } else {
                  error.cause = `ClipboardService: ${error.cause}`;
                  throw error;
                }
              });
          });
        },

        /**
         * Replaces the clipboard content of the currently logged in user with
         * the 'clips' in the given Array.
         *
         * @async
         * @param {Array} clips - An array of clips: [{ id, type },...]
         * @returns {Array} - The actual clipboard clips put in the clipboard
         * @throws {atex.aceui.error.Error}
         */
        putInClipboard: (clips) => {
          return AuthenticationService.getCurrentUser ()
            .then (({ principalId, userId }) => {
              let clipboardAlias = CLIPBOARD_ALIAS (principalId || userId);
              DEBUG && console.log ('PUT - GET CLIPBOARD CONTENT FOR', principalId||userId);
              return ContentService.getContent ({ alias: 'aceUI/' + clipboardAlias })
                .catch ((error) => {
                  if (error.type === atex.aceui.error.types.NOT_FOUND) {
                    DEBUG && console.log ('PUT - CLIPBOARD NOT FOUND, CREATE NEW');
                    return ContentService.createContent ({
                      content: {
                        operations: [{ _type: 'aceSetAlias', namespace: 'aceUI', alias: clipboardAlias }],
                        aspects: { aceClipboard: { description: `AceUI Clipboard for ${principalId || userId}`, content: [] }},
                        system: { contentType: 'aceClipboardContent' }
                      }
                    });
                  } else {
                    error.cause = `ClipboardService: ${error.cause}`;
                    throw error;
                  }
                })
                .then ((response) => {
                  DEBUG && console.log ('PUT - UPDATE CLIPBOARD', response);
                  response.content.aspects.aceClipboard.content = clips;
                  return ContentService.updateContent ({
                    alias: response.content.system.id,
                    content: response.content,
                    revision: response.revision
                  });
                })
                .then ((response) => {
                  return atex.aceui.ObjectUtils.getByPath (response, 'content/aspects/aceClipboard/content');
                });
            });
        },

        /**
         * Called whenever the clipboard content is updated
         * @callback clipboardUpdateCallback
         * @param {Array} - An array of (the updated) clips: [{ id, type },...]
         */

        /**
         * Subscribe to clipboard updates of the current user's clipboard.
         * Use the returned function to unsubscribe.
         *
         * @param {clipboardUpdateCallback}
         * @returns {Function} - An unsubscribe function taking no arguments.
         */
        subscribe: (callback) => {
          return ContentEventService.subscribe ('CLIPBOARD_UPDATE', (event) => {
            AuthenticationService.getCurrentUser ()
              .then (({ principalId, userId }) => {
                getContent ({ alias: CLIPBOARD_ALIAS (principalId || userId), namespace: 'aceUI' })
                  .then ((response) => {
                    // rather compare versions?
                    if (event.system.mainAlias === response.content.system.id) {
                      let clips = atex.aceui.ObjectUtils.getByPath (response, 'content/aspects/aceClipboard/content') || [];
                      callback (clips);
                    }
                  })
                  .catch ((error) => {
                    ErrorMessagingService.sendError (error);
                  });
              });
          });
        }
      };
    }
  ]);
